/**
 * How to combine result of all condition satisfy
 */
export var ConditionCombinationType;
(function (ConditionCombinationType) {
    ConditionCombinationType["All"] = "All";
    ConditionCombinationType["Any"] = "Any";
})(ConditionCombinationType || (ConditionCombinationType = {}));
